import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

import {ExtraDeliveryState} from './slicer';
import {
  confirmExtraDelivery,
  createExtraDeliveryPreorder,
  deleteExtraDelivery,
  getExtraDeliveryDetail,
  getExtraDeliveryList,
  getExtraDeliveryPlans,
  pauseExtraDelivery
} from './thunk';

export const extraDeliveryBuilder = (builder: ActionReducerMapBuilder<ExtraDeliveryState>) => {
  builder
    .addCase(getExtraDeliveryList.pending, (state: any) => {
      state.loading = true;
    })
    .addCase(getExtraDeliveryList.fulfilled, (state: any, action: any) => {
      const payload = action.payload;
      if (state.list && state.list.page !== payload?.page) {
        state.list = {
          ...payload,
          items: [...(state.list.items || []), ...(payload?.items || [])]
        };
      } else {
        state.list = payload ?? null;
      }
      state.loading = false;
    })
    .addCase(getExtraDeliveryList.rejected, (state: any) => {
      state.loading = false;
    })
    .addCase(createExtraDeliveryPreorder.pending, (state: any) => {
      state.create.loading = true;
    })
    .addCase(createExtraDeliveryPreorder.fulfilled, (state: any) => {
      state.create.loading = false;
    })
    .addCase(createExtraDeliveryPreorder.rejected, (state: any) => {
      state.create.loading = false;
    })
    .addCase(getExtraDeliveryPlans.pending, (state: any) => {
      state.plansLoading = true;
    })
    .addCase(getExtraDeliveryPlans.fulfilled, (state: any, action: any) => {
      state.plans = action.payload.data ?? null;
      state.plansLoading = false;
    })
    .addCase(getExtraDeliveryPlans.rejected, (state: any) => {
      state.plansLoading = false;
    })
    .addCase(confirmExtraDelivery.pending, (state: any) => {
      state.confirm.loading = true;
    })
    .addCase(confirmExtraDelivery.fulfilled, (state: any, action: any) => {
      state.confirm.loading = false;
      state.confirm.result = action.payload
        ? {
            state: action.payload.state,
            start_time: action.payload.start_time,
            end_date: action.payload.end_date
          }
        : null;
    })
    .addCase(confirmExtraDelivery.rejected, (state: any) => {
      state.confirm.loading = false;
    })
    .addCase(getExtraDeliveryDetail.pending, (state: any) => {
      state.detailLoading = true;
      state.details = null;
    })
    .addCase(getExtraDeliveryDetail.fulfilled, (state: any, action: any) => {
      state.details = action.payload.data;
      state.detailLoading = false;
    })
    .addCase(getExtraDeliveryDetail.rejected, (state: any) => {
      state.detailLoading = false;
      state.details = null;
    })
    .addCase(deleteExtraDelivery.pending, (state: any) => {
      state.remove.loading = true;
    })
    .addCase(deleteExtraDelivery.fulfilled, (state: any) => {
      state.remove.loading = false;
    })
    .addCase(deleteExtraDelivery.rejected, (state: any) => {
      state.remove.loading = false;
    })
    .addCase(pauseExtraDelivery.pending, (state: any) => {
      state.pause.loading = true;
    })
    .addCase(pauseExtraDelivery.fulfilled, (state: any) => {
      state.pause.loading = false;
    })
    .addCase(pauseExtraDelivery.rejected, (state: any) => {
      state.pause.loading = false;
    });
};
